var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOpenNewTab = function SvgOpenNewTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.222 0v1.778H1.778v12.444h12.444V9.778H16v5.333c0 .491-.398.889-.889.889H.89A.889.889 0 0 1 0 15.111V.89C0 .398.398 0 .889 0h5.333Zm6.743 1.778H8.89V0H16v7.111h-1.778V3.035L8 9.257 6.743 8l6.222-6.222Z",
    fill: "#47BDAB"
  })));
};
export default SvgOpenNewTab;